import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Configuration } from '@shared/models/configuration';
import { DynamicGridKendoSelectionEvent } from '@shared/models/dynamic-grid-kendo-selected-event.model';
import { ParticleService } from '@core/services/particle.service';
import { SmartGridService } from '@core/services/smart-grid.service';
import { ISmartGridDataState } from '@shared/store/reducers/smart-grid.reducers';
import { DeleteAlertsCommand } from '../../commands/notifications.commands';
import { NotificationRelativePath } from '../../constants/notification-relative-path';
import { NotificationGridConfig } from '../../constants/notification-grid-config';
import { SelectableSettings } from '@progress/kendo-angular-grid'; // needed for package publish
import { DeleteNotificationsAction } from '../../store/actions/notifications.actions';
import { INotificationsState } from '../../store/reducers/notifications.reducers';
import { AlertTitleCellViewerComponent } from '../cell-components/alert-title-cell-viewer/alert-title-cell-viewer.component';
import { NotificationStateCellViewerComponent } from '../cell-components/notification-state-cell-viewer/notification-state-cell-viewer.component';

@Component({
    standalone: false,
    selector: 'lib-notification-content',
  templateUrl: './notification-content.component.html',
  styleUrls: ['./notification-content.component.scss']
})
export class NotificationContentComponent implements OnInit, OnDestroy {

  sourceType = NotificationGridConfig.SOURCE_TYPE;
  tabs = NotificationGridConfig.TABS;
  selectableSettings: SelectableSettings | boolean = false;
  currentTabIndex: number;
  currentSelectedRows = [];
  routeSubscription$: Subscription;

  constructor(
    private smartGridService: SmartGridService,
    private smartGridStore: Store<ISmartGridDataState>,
    private particleService: ParticleService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private notificationsStore: Store<INotificationsState>
  ) {
    this.particleService.registerCellComponent('AlertTitleCellViewer', AlertTitleCellViewerComponent);
    this.particleService.registerCellComponent('NotificationStateCellViewer', NotificationStateCellViewerComponent);
  }

  ngOnInit() {
    this.routeSubscription$ = this.activatedRoute.queryParams.subscribe(params => {
      this.currentTabIndex = +params['tab'] || 0;
      this.onTabChange(this.currentTabIndex);
    });
    // this.smartGridService.initDataProvider(this.sourceType);
  }

  onTabChange(tabIndex) {
    this.selectableSettings = (tabIndex === 1) ? NotificationGridConfig.SELECTABLE_SETTINGS : false;
    const gridConfig = Configuration.getSmartGridConfig(this.sourceType);
    gridConfig.ItemsUrlIndex = tabIndex;
    Configuration.setSmartGridConfig(this.sourceType, gridConfig);
    this.smartGridService.initDataProvider(this.sourceType);
    this.currentTabIndex = tabIndex;
  }

  onClickAddNotification() {
    this.router.navigate(NotificationRelativePath.AddNotificationUrl);
  }

  onSelectionChanged(event: DynamicGridKendoSelectionEvent) {
    this.currentSelectedRows = event.allSelectedRows;
  }

  onClickDelete() {
    const subscriptionIds = this.currentSelectedRows.map(row => {
      return row.dataItem.id;
    });
    const command = new DeleteAlertsCommand(subscriptionIds);
    this.notificationsStore.dispatch(new DeleteNotificationsAction(command, this.sourceType));
  }

  ngOnDestroy() {
    this.routeSubscription$.unsubscribe();
  }
}
